{
  "ChangeUserAgent_Title": "Set Browser Display Profile",
  "ChangeUserAgent_SubTitle": "Select the browser display profile that you wish to view web page content in within your current web session on this computer.",
  "ChangeUserAgent_FieldName_BrowserProfile": "Browser Profile",
  "ChangeUserAgent_Options_ForceAutomaticBrowserDetection": "[Force Automatic Browser Detection]",
  "ChangeUserAgent_FooterActions_Apply": "Apply",
  "ChangeUserAgent_FooterActions_Cancel": "Cancel",
  "NAME": "ChangeUserAgentLanguage"
}